import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, User } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent } from "../components/ui/card";
const API = process.env.REACT_APP_BACKEND_URL;
export default function SellerLogin() {
  const nav = useNavigate(),
    [username, setUsername] = useState(""),
    [password, setPassword] = useState(""),
    [error, setError] = useState(""),
    [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      let { data } = await axios.post(
        `${API}/api/inventory/auth/seller-login`,
        { username, password },
      );
      localStorage.setItem("e93_inventory_seller_token", data.token);
      nav("/seller");
    } catch (e) {
      setError(e.response?.data?.detail || "Gabim në lidhje");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen bg-emerald-950 flex items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-10">
          <div className="text-center mb-8">
            <img
              src="/e93-logo.jpg"
              alt="E93"
              className="inline-block w-20 h-20 rounded-full object-cover mb-4"
            />
            <h1 className="text-3xl font-bold">Paneli i Shitësit E93</h1>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label>Përdoruesi</Label>
              <div className="relative mt-2">
                <User className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <Input
                  className="pl-10"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
            </div>
            <div>
              <Label>Fjalëkalimi</Label>
              <div className="relative mt-2">
                <Lock className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <Input
                  className="pl-10"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            {error && <p className="text-red-700 bg-red-50 p-3">{error}</p>}
            <Button className="w-full py-6 bg-emerald-700" disabled={loading}>
              {loading ? "Duke hyrë..." : "Hyr si Shitës"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
